import { render, staticRenderFns } from "./narrowTemplate.vue?vue&type=template&id=5cb3c421&"
import script from "./narrowTemplate.vue?vue&type=script&lang=js&"
export * from "./narrowTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports